import { compose } from 'recompose';
import withPermissions from '../../../../auth/utils/withPermissions';
import withTimezone from '../../../../auth/utils/withTimezone';
import withActiveUserIdAndType from '../../../../common/hoc/withActiveUserIdAndType';
import withDateFormat from '../../../../auth/utils/withDateFormat';

const CustomerFormContainer = compose(
  withActiveUserIdAndType(),
  withPermissions,
  withTimezone,
  withDateFormat(),
);

export default CustomerFormContainer;

